export default __webpack_public_path__ + "static/media/cryptora-r.a30b080d.png";